const { default: parentApi } = require("store/parentApi");

const dashboardApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    // ── V1 endpoints (original dashboard) ────────────────────────────────
    getPerformanceTrend: build.query({
      query: (body) => ({
        url: "dashboard/performace-trend",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardPerformanceTrend"],
    }),
    getDashboardStats: build.query({
      query: (body) => ({
        url: "dashboard/stats",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardStats"],
    }),
    getActiveUsers: build.query({
      query: () => ({
        url: "/user/list/active/users",
        method: "GET",
      }),
      transformResponse: (response) => response?.data?.data ?? response?.data ?? response ?? [],
      providesTags: ["dashboardActiveUsers"],
    }),

    // ── V2 endpoints (DashboardV2) ────────────────────────────────────────
    getDashboardV2Stats: build.query({
      query: (body) => ({
        url: "dashboard/v2/stats",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2Stats"],
    }),
    getDashboardV2PerformanceTrend: build.query({
      query: (body) => ({
        url: "dashboard/v2/performace-trend",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2PerformanceTrend"],
    }),
    // Activity heatmap — one aggregated entry per active day, last 12 months
    getDashboardV2ActivityHeatmap: build.query({
      query: (body) => ({
        url: "dashboard/v2/activity-heatmap",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2ActivityHeatmap"],
    }),
    // Performance by attribute — grouped accuracy per specialty / script / topic / explanation
    getDashboardV2PerformanceByAttribute: build.query({
      query: (body) => ({
        url: "dashboard/v2/performance-by-attribute",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2PerformanceByAttribute"],
    }),
    // Score distribution — all completed quizzes for a user within an optional
    // date range. Used by the Score Distribution card + Performance by Script.
    getDashboardV2ScoreDistribution: build.query({
      query: (body) => ({
        url: "dashboard/v2/score-distribution",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2ScoreDistribution"],
    }),
    // Dedicated chart endpoint — same shape as performace-trend but
    // accuracyTrend entries also include correct + incorrect counts
    getDashboardV2PerformanceChart: build.query({
      query: (body) => ({
        url: "dashboard/v2/performance-chart",
        method: "POST",
        body,
      }),
      transformResponse: (response) => response?.data ?? response,
      providesTags: ["dashboardV2PerformanceChart"],
    }),
  }),
});

export const {
  useGetPerformanceTrendQuery,
  useLazyGetPerformanceTrendQuery,
  useGetDashboardStatsQuery,
  useLazyGetDashboardStatsQuery,
  useGetActiveUsersQuery,
  useGetDashboardV2StatsQuery,
  useLazyGetDashboardV2StatsQuery,
  useGetDashboardV2PerformanceTrendQuery,
  useLazyGetDashboardV2PerformanceTrendQuery,
  useGetDashboardV2PerformanceChartQuery,
  useLazyGetDashboardV2PerformanceChartQuery,
  useGetDashboardV2ActivityHeatmapQuery,
  useLazyGetDashboardV2ActivityHeatmapQuery,
  useGetDashboardV2ScoreDistributionQuery,
  useLazyGetDashboardV2ScoreDistributionQuery,
  useGetDashboardV2PerformanceByAttributeQuery,
  useLazyGetDashboardV2PerformanceByAttributeQuery,
} = dashboardApis;
